import { render, staticRenderFns } from "./cardSecondary.vue?vue&type=template&id=6ca31cdc&scoped=true&"
import script from "./cardSecondary.vue?vue&type=script&lang=js&"
export * from "./cardSecondary.vue?vue&type=script&lang=js&"
import style0 from "./cardSecondary.vue?vue&type=style&index=0&id=6ca31cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca31cdc",
  null
  
)

export default component.exports